export const CASCADING_TAGS = ['title', 'meta'] as const
export type CascadingTags = (typeof CASCADING_TAGS)[number]

export type ValidTags = CascadingTags | 'link'
